import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useCallback, useState } from "react";
import ExperimentMachineListPageHeader from "../../organisms/ExperimentsMachinePage/ExperimentMachineListPageHeader";
import ExperimentMachinePageFooter from "../../organisms/ExperimentsMachinePage/ExperimentMachinePageFooter";
import ExperimentMachinePageMiddle from "../../organisms/ExperimentsMachinePage/ExperimentMachinePageMiddle";
import ExperimentMachinePageHeader from "../../organisms/ExperimentsMachinePage/ExperimentMachinePageHeader";
import ExperimentMachineListPageMiddle2 from "../../organisms/ExperimentsMachinePage/ExperimentMachineListPageMiddle2";
import StimulusManagerOnlyPage from "../../organisms/ExperimentsMachinePage/StimulusManagerOnlyPage";
import Api from "../../../API/API";
import cookie from "../../../API/cookie";

// Battery Service UUIDs
const BAS_SERVICE_UUID = "0000180f-0000-1000-8000-00805f9b34fb";
const BAS_LEVEL_UUID   = "00002a19-0000-1000-8000-00805f9b34fb";

function ExperimentsMachinePage() {
  const [state, setState] = useState(false);
  const [viewMode, setViewMode] = useState("main"); // main | stimulus
  const [mornitoringState, setMornitoringState] = useState();
  const [machine, setMachine] = useState();          // GATT server or service from child
  const [starttime , setStarttime] = useState();
  const [data, setData] = useState([]);
  const [battery, setBattery] = useState(null);      // null = unknown
  
  
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Refs to avoid reattaching listeners
  const batteryCharRef = useRef(null);
  const deviceRef = useRef(null);
  const pollRef = useRef(null);

  const hightFunction = (
    t,
    bluetoothService,  // could be a GATT server OR a service, depending on your child code
    starttimeValue
  ) => {
    setState(true);
    setMachine(bluetoothService);
    setStarttime(starttimeValue);
    setViewMode("main");
  };


  const handleMachineReconnect = (bluetoothService) => {
    setMachine(bluetoothService);
  };

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("loginPopupShown");
    
    // POPUP flag
    setShowLoginPopup(false);
    sessionStorage.setItem("loginPopupShown", "1");

    /*
    if (!alreadyShown) {
      setShowLoginPopup(true);
      sessionStorage.setItem("loginPopupShown", "1");
    }
    */
  }, []);


  const hightFunction2 = (text) => setMornitoringState(text);

  // Stable handler (same function identity)
  const onBatteryLevel = useCallback((event) => {
    const dv = event.target.value;    // DataView
    const level = dv.getUint8(0);     // 0–100
    setBattery((prev) => (prev === level ? prev : level));
    // console.log("Battery Level:", level, "%");
  }, []);

  const handleDisconnect = useCallback(() => {
    setBattery(null);
    // Clear polling if any
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, []);

  // Subscribe when `machine` becomes available; cleanup on change/unmount
  useEffect(() => {
    if (!machine) return;

    let cancelled = false;

    (async () => {
      try {
        // Figure out what `machine` is
        let server = null;
        let basService = null;

        if (typeof machine.getPrimaryService === "function") {
          // Looks like BluetoothRemoteGATTServer
          server = machine;
        } else if (machine?.device?.gatt && typeof machine.device.gatt.getPrimaryService === "function") {
          // Looks like a Service; we still can navigate via device.gatt
          server = machine.device.gatt;
        } else if (machine?.uuid === BAS_SERVICE_UUID) {
          // Already the BAS service
          basService = machine;
        }

        if (!basService) {
          basService = await server?.getPrimaryService(BAS_SERVICE_UUID).catch(() => null);
        }
        if (cancelled || !basService) return;

        const batteryChar = await basService.getCharacteristic(BAS_LEVEL_UUID);
        batteryCharRef.current = batteryChar;
        deviceRef.current = basService.device ?? server?.device ?? null;

        // Initial read so UI updates immediately
        try {
          const v = await batteryChar.readValue();
          if (!cancelled) onBatteryLevel({ target: { value: v } });
        } catch (e) {
          console.warn("Initial battery read failed:", e);
        }

        // Notifications if supported (notify or indicate)
        const canNotify = batteryChar.properties?.notify || batteryChar.properties?.indicate;
        if (canNotify) {
          await batteryChar.startNotifications();
          batteryChar.addEventListener("characteristicvaluechanged", onBatteryLevel);
        }

        // Poll fallback every 60s (helps devices that rarely push)
        pollRef.current = setInterval(async () => {
          try {
            const ch = batteryCharRef.current;
            if (!ch) return;
            const v = await ch.readValue();
            onBatteryLevel({ target: { value: v } });
          } catch {}
        }, 60000);

        // Also refresh once when tab becomes visible again
        const onVis = async () => {
          if (document.visibilityState === "visible" && batteryCharRef.current) {
            try {
              const v = await batteryCharRef.current.readValue();
              onBatteryLevel({ target: { value: v } });
            } catch {}
          }
        };
        document.addEventListener("visibilitychange", onVis);

        // Reset on disconnect
        if (deviceRef.current) {
          deviceRef.current.addEventListener("gattserverdisconnected", handleDisconnect);
        }

        // Cleanup installer
        return () => {
          document.removeEventListener("visibilitychange", onVis);
        };
      } catch (e) {
        console.error("Battery setup failed:", e);
      }
    })();

    return () => {
      cancelled = true;
      try {
        if (pollRef.current) {
          clearInterval(pollRef.current);
          pollRef.current = null;
        }
        if (batteryCharRef.current) {
          batteryCharRef.current.removeEventListener("characteristicvaluechanged", onBatteryLevel);
          batteryCharRef.current.stopNotifications?.();
          batteryCharRef.current = null;
        }
        if (deviceRef.current) {
          deviceRef.current.removeEventListener("gattserverdisconnected", handleDisconnect);
          deviceRef.current = null;
        }
      } catch {}
    };
  }, [machine, onBatteryLevel, handleDisconnect]);

  // 공통 컨테이너 스타일 (반응형)
  const outerContainerStyle = {
    backgroundColor: "#191919",
    minHeight: "100vh",
    width: "100%",
    boxSizing: "border-box",
    padding: "16px 12px 32px", // mobile-friendly padding
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflowX: "hidden",
  };

  const innerContainerStyle = {
    width: "100%",
    // maxWidth: "1200px",  // ❌ 이거 제거해서 PC에서도 꽉 차게
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  };

  return (
    <>
      {state == false ? (
        <>
          <Box style={outerContainerStyle}>
            <Box style={innerContainerStyle}>
              <ExperimentMachinePageHeader />
              <ExperimentMachinePageMiddle propFunction={hightFunction} />
              <ExperimentMachinePageFooter />
            </Box>
          </Box>
        </>
      ) : (
        <Box style={outerContainerStyle}>
          <Box style={innerContainerStyle}>
          <ExperimentMachineListPageHeader battery={battery} />
          {viewMode === "main" ? (
            <ExperimentMachineListPageMiddle2
              starttime={starttime}
              data={data}
              machine={machine}
              propFunction={hightFunction2}
              onOpenStimulusManager={() => setViewMode("stimulus")}
              onMachineReconnect={handleMachineReconnect}   // 🔹 추가
            />
          ) : (
            <StimulusManagerOnlyPage onBack={() => setViewMode("main")} />
          )}
            <ExperimentMachinePageFooter />
          </Box>
        </Box>
      )}

      <Dialog
        open={showLoginPopup}
        onClose={() => setShowLoginPopup(false)}
      >
        <DialogTitle>기기 지원 종료 관련</DialogTitle>
        <DialogContent>
          <Typography>
          안녕하세요. 보다 안정적이고 향상된 성능의 서비스 제공을 위해, 2025년 12월 31일부로 구버전 기기에 대한 지원이 종료될 예정입니다.
          <br/>
          <br/>
          기기 업데이트 및 전환 관련 문의는 아래 연락처로 편하게 문의해 주시기 바랍니다.
          <br/><br/>
          010-9425-3617          
        </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLoginPopup(false)} autoFocus>
            확인
          </Button>
        </DialogActions>
      </Dialog>


    </>
  );
}

export default ExperimentsMachinePage;
